import React from "react";

const LeftTime = ({ time }) => {
  return <div className="text-xs text-slate-500 font-medium">{time}</div>;
};

export default LeftTime;
